import { Routes, RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthguardService } from './guards/authguard.service';
import { SignalRResolver } from './resolvers/signalr.resolver';
import { LoginComponent } from './components/login/login.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { ReportComponent } from './components/report/report.component';
import { WidgetdetailsComponent } from './components/shared/widgetdetails/widgetdetails.component';

const appRoutes: Routes = [
    { path: 'login', component: LoginComponent },
    { path: 'home', component: DashboardComponent, canActivate: [AuthguardService], resolve: SignalRResolver },
    { path: 'reports', component: ReportComponent, canActivate: [AuthguardService] },
    { path: 'widgetdetails', component: WidgetdetailsComponent, canActivate: [AuthguardService] },

    // default path
    { path: '', component: LoginComponent },
    //if no path matches
    { path: '**', component: LoginComponent, canActivate: [AuthguardService] }
];
@NgModule({
    //imports: [RouterModule.forRoot(appRoutes, { enableTracing: true })],
    imports: [RouterModule.forRoot(appRoutes)],
    exports: [RouterModule],
    declarations: []
})
export class AppRoutingModule { }


// WEBPACK FOOTER //
// ./src/app/app.routing.ts